import React from 'react';
import Header from '../../../Reusable/Header';
import Footer from '../../../Reusable/Footer';
import MembershipFormInner from './MembershipForm/MembershipFormInner';

const MembershipForm = () => {
    return (
        <div>
            <Header />
            <MembershipFormInner />
            <Footer />
        </div>
    );
};

export default MembershipForm;
